<template>
  <form @submit.prevent="handleSubmit">
    <div class="row">
      <div v-if="maintenance_schedule.account" class="form-group col-sm-12">
          <label for="account_id">Account:</label>
          <input class="form-control" disabled name="account_id" type="text" v-model="maintenance_schedule.account.account_name">
      </div>
      <div class="form-group col-sm-12 col-md-12 required">
        <label for="account_id">Maintenance Name:</label>
        <input class="form-control" required="" name="maintenance_name" type="text" v-model="maintenance_schedule.maintenance_name">
      </div>   
      <div class="form-group col-sm-12 required">
        <label for="vehicle_id">Vehicle:</label>
        <Multiselect mode="multiple" required v-model="value_multiple_vehicle" :options="vehicleOptions" valueProp="valueProp" label="label" :searchable="true">
          <template v-slot:multiplelabel="{ values }">
            <div class="multiselect-multiple-label">
              <span v-for="(item2, index2) in values" :key="index2">{{item2.label}},&nbsp;&nbsp;</span>
            </div>
          </template>
        </Multiselect>
      </div>
      <div class="form-group col-sm-12 col-md-4 required">
        <label for="type">Type:</label>
        <select class="form-control" name="type" v-model.number="maintenance_schedule.type">
          <option value="1" style="color:black;">Service</option>
          <option value="2" style="color:black;">Inspection</option>
          <option value="3" style="color:black;">Repair / Accident</option>
          <option value="4" style="color:black;">Others</option>
        </select>
      </div>
      <div class="form-group col-sm-12 col-md-4 required">
        <label for="status">Schedule Type:</label>
        <select class="form-control" name="status" v-model.number="maintenance_schedule.maintenance_type">
          <option value="1" style="color:black;">After Certain KM Reached</option>
          <option value="2" style="color:black;">After Certain Month Passed</option>
        </select>
      </div>
      <div v-if="maintenance_schedule.maintenance_type == 1" class="form-group col-sm-12 col-md-4 required">
        <label for="status">KM Vehicle:</label>
        <input class="form-control" name="maintenance_name" type="number" v-model.number="maintenance_schedule.km_vehicle" step="any" min="0" required>
      </div>
      <div v-else class="form-group col-sm-12 col-md-4 required">
        <label for="status">Month Passed Since Last Maintenance:</label>
        <input class="form-control" name="maintenance_name" type="number" v-model.number="maintenance_schedule.schedule_month" min="1" max="12" required>
      </div>      
      <div class="form-group col-sm-12 col-md-12 required">
        <label for="cost_estimation">Cost Estimation (Part Usage + Additional Cost):</label>
        <input class="form-control" name="cost_estimation" type="number" v-model.number="maintenance_schedule.cost_estimation" required>
      </div>
      <div class="form-group col-sm-12">
        <input class="btn btn-primary" type="submit" value="Save">
        <router-link class="btn btn-default ml-1" to="/maintenance_schedules">Cancel</router-link>
      </div>
    </div>
    <div v-if="this.onRequest" class="modal-backdrop fade show" style="display:flex; align-items: center; justify-content: center;">
      <img :src="require('../assets/loading.gif')"/>
    </div>
  </form>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import Multiselect from '@vueform/multiselect'
  export default {
    components:{
      Multiselect,
    },
    computed: {
        ...mapState('maintenance_schedules', ['maintenance_schedule', 'onRequest']),
        ...mapState('vehicles', ['vehicles']),
    },
    data(){
      return {        
        vehicleOptions: [],
        value_multiple_vehicle: null,
      }
    },
    methods: {
      handleSubmit(){
        if(this.onRequest) return;
        let res = []
        this.value_multiple_vehicle.map(item => {
          res.push({vehicle_id: item})
        })
        this.maintenance_schedule.maintenance_schedule_vehicle = res
        this.edit(this.maintenance_schedule)
      },
      ...mapActions('maintenance_schedules', ['edit', 'get']),
      ...mapActions('vehicles', {getVehicles: 'get_vehicle_by_account'}),
    },
    created() {
      this.$emit('onChildInit', 'Edit Maintenance Schedule')
      this.get(this.$route.params.id)
    },
    watch:{
      maintenance_schedule(nextState, prevState){
        if(nextState !== prevState){
          if(nextState.account_id){
            this.getVehicles({account_id : nextState.account_id})
            this.value_multiple_vehicle = nextState.maintenance_schedule_vehicle.map(item => item.vehicle_id)
          }
          return
        }
      },      
      vehicles(nextState, prevState){
        if(nextState !== prevState){
          this.vehicleOptions = []
          if(nextState.length > 0){
            nextState.map(item => {
              this.vehicleOptions.push({valueProp:item.id, label:item.vehicle_no + ' - ' + item.vehicle_code})
            })
          }
          return
        }
      },
    }
  }
</script>
